import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ObjectUnsubscribedError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UtilService } from 'src/app/core/services/util.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/core/models/persons.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import {
  Evento,
  Evento_TiposEventos,
  Evento_Rastreador_Fabricante,
  Evento_OrigemMensagem,
  Evento_EstadosPortas_equipamento,
  Evento_EstadosPortas_tipo,
  Evento_EstadosPortas_estadoSaida,
} from '../../../../assets/proto-ts/evento';
import { GoogleMap } from '@angular/google-maps';
import * as protobuf from 'protobufjs';
import { UserAudit } from 'src/app/core/models/userAudit';
import { PositionsService } from 'src/app/core/services/positions.service';
import { FideGatewayService } from 'src/app/core/services/findGateway.service';
import {
  PEGDetails,
  PEGFlow,
  PEGinterface,
} from 'src/app/core/models/peg.model';
import * as mermaid from 'mermaid';
import { trigger } from '@angular/animations';
// import * as svgPanZoom from 'svg-pan-zoom';
import { ClipboardService } from 'ngx-clipboard';
import { Loader } from '@googlemaps/js-api-loader';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

protobuf;
@Component({
  selector: 'app-utils',
  templateUrl: './utils.component.html',
  styleUrls: ['./utils.component.scss'],
  providers: [DatePipe],
})
export class UtilsComponent implements OnInit {
  user: User;
  isUserAdmin = false;
  isUserAll = false;
  apiServerProd = environment.production;
  isLocalhost = window.location.hostname.startsWith('localhost');
  files : any [] = [];
  consumer : any | null = null;

  templateTableLaTEXT = [
    '\\begin{table}[H]',
    '\\begin{tabular}{| p{15.55cm}|}',
    '\\hline',
    '{\\cellcolor[HTML]{C0C0C0}\\textbf{{\\scriptsize |CASO_DE_TESTE|} }}\\\\ \\hline',
    '{{\\underline{\\scriptsize Sumário:}}}\\\\',
    '{\\scriptsize |SUMARIO|}\\\\ \\hline',
    '\\scriptsize{Último Status:}\\hspace{2mm}|STATUS| \\\\ \\hline',
    '\\scriptsize{Baseline:}\\hspace{8mm}|BASELINE| \\\\ \\hline',
    '{{\\scriptsize Comentário:}}\\\\\\scriptsize |COMENTARIO|\\\\ \\hline',
    '\\end{tabular}',
    '\\end{table}',
  ];
  textTableLatexOut: string = '';
  selectedFiles: any;
  breakLineToDotPeriodInput: string = '';
  breakLineToDotPeriodOutput: string[] = ['', '0'];

  // Dump
  circularProgressiveWaitDump = false;
  circularProgressiveWaitLoraCacheModalDump = false;
  seriaListDump: { serial: string; status: string; timeRemaining: string }[] =
    [];
  seriaisDump = '';
  timeToDump = 86400;

  supplierPrepareToDumpSupplierSelect = 'maxtrack';
  resultPrepareToDump = '';

  // End Dump
  // LoraCache
  circularProgressiveWaitLoraCache = false;
  circularProgressiveWaitLoraCacheModalStatus = false;
  circularProgressiveWaitFindMyCache = false;

  serialLoraIdCache: { found: string; notFound: string } = {
    found: '',
    notFound: '',
  };
  serialCacheLora: string = '';
  insertCacheLora: LoraCache[] = [];
  insertCacheFindMy : string = '';
  removerCacheFindMy : string = '';
  listCacheFindMy : FindMyCache[] = [];
  listCacheFindMyLote : any [] = []
  messageListCacheFindMy : string = '';
  messageCreatListCacheFindMy : string = '';
  responseCreateListCacheFindMy : any[] = []; 
  responseCreateListCacheFindMyLote : any[] = [];
  responseRemoveListCacheFindMyLote : any[] = [];
  searchCacheFindMy : string = '';
  responseSearchListCacheFindMy : any[] = [];
  // End LoraCache

  //GeneratePosition
  maps: GoogleMap | any;

  drawingManager: any;
  apiLoaded: Observable<boolean>;
  options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 4,
  };
  googleProtobuf: any;
  event: Evento = Evento.fromJSON('{}');
  marker: any;
  eventLst: NewEvento[] = [];
  eventProto: any = {
    tipo_evento: [],
    fabricante: [],
    origem_mensagem: [],
    estado_saida: [],
    equipamento: [],
    tipo: [],
  };
  newEvento: NewEvento = new NewEvento();
  newEventoSupport: NewEventoSupport = new NewEventoSupport();
  eventResult: { status: number; packet: string }[] = [
    { status: 0, packet: '' },
  ];
  ufLst: string[] = [];
  cityLst: { name: string; lat: string; lng: string }[] = [];
  circularProgressiveCity = false;
  //End GeneratePosition

  // Send to DEV
  serialSendToDEV: string = '';
  dateStartSendToDEV: string = '';
  dateEndSendToDEV: string = '';
  sendToDevPort: number = 9002;
  circularProgressiveWaitSendToDEV: boolean = false;
  supplierSelectSendToDev: { name: string; port: number }[] = [
    { name: 'Maxtrack', port: 9002 },
    { name: 'Mobilogix', port: 9001 },
  ];

  // End to Send to DEV

  //Search Gateway
  circularProgressiveWaitSearchGateway: boolean = false;
  gateways: Gateway[] = [];
  gatewaysSeriais: string = '';

  userAudit: UserAudit;
  //PEG
  PEGDetails: PEGDetails = new PEGDetails();
  PEGFlow: PEGFlow[] = [];
  PEGAnalytic: any = { Accumulators: [], Flags: [], Pegs: [] };
  PEGMemaidAux: string[] = [''];
  circularProgressiveWaitPEGMermaid = false;
  PEGFlagUseWHENIFTHENNomeclature = true;

  //parserAux
  parser: Parser = {
    deviceName: 'MT-2000',
    parserPacket: [
      {
        firmware: ['1.3.10'],
        type: 'ALL',
        sep: ':',
        headerSep: '=',
        filterGroup: [],
        filterParam: [],
        paramGroup: [
          'HEADER',
          'NTW',
          'NTW',
          'NTW',
          'NTW',
          'NTW',
          'NTW',
          'NTW',
          'FREQ',
          'FREQ',
          'FREQ',
          'FREQ',
          'FREQ',
          'MOD',
          'MOD',
          'MOD',
          'MOD',
          'MOD',
          'REPORT',
          'REPORT',
          'REPORT',
          'TAG',
          'BAT',
          'BAT',
          'BAT',
          'BAT',
          'BAT',
          'ENGINEV',
          'ACM',
          'ACM',
          'ACL',
          'ACL',
          'ACL',
          'ACL',
          'PWD',
          'STI',
          'RELAY',
          'BLK',
          'BLK',
          'MOM',
          'MOM',
          'GEOFENCE',
          'GEOFENCE',
          'GEOFENCE',
          'ADT',
          'ADT',
          'ADT',
          'ADT',
          'ADT',
          'JAM',
          'JAM',
          'JAM',
          'JAM',
          'JAM',
        ],
        param: [
          'HEADER',
          'APN',
          'USR',
          'PWD',
          'URL1',
          'PT1',
          'URL2',
          'PT2',
          'T3',
          'T23',
          'SLEEPT',
          'HBEAT',
          'T15',
          'SLEEPM',
          'IGTM',
          'SENDP',
          'TRANSM',
          'WDOGR/PACKS',
          'ANGLE',
          'DIST',
          'OVERSPD',
          'TAG',
          'LBV',
          'HBV',
          'INT-LBV',
          'INT-HBV',
          'BOUNCE',
          'ENGINEV',
          'ODO-TOTAL[mt]',
          'HOURMETER[min]',
          'MOVE-CNT',
          'MOVE-TH',
          'IGT-ON-BOUNCE',
          'IGT-OFF-BOUNCE',
          'PWD',
          'STI',
          'RELAY',
          'APN-LOCK',
          'URL-LOCK',
          'URL-MOM',
          'PT-MOM',
          'GF-LAT',
          'GF-LONG',
          'RAD',
          'STAR-HOP',
          'CIRC-BUFF',
          'NET_WDG',
          'GPIO-BOUNCE',
          '<Reserved>',
          'SENSE',
          'ATACK_TIME',
          'ACL_FLAG',
          'BLOCK_TIME',
          '<Reserved>',
        ],
        value: [['']],
        packet: [],
      },
    ],
  };

  deviceNearby: DeviceNearby = new DeviceNearby();
  deviceNearbyFilter: DeviceNearby = new DeviceNearby();

  deviceNearbyMapLatLngMarker: any;
  deviceNearbyMapLatLngRadius: { lat: number; lng: number; radius: number } = {
    lat: 0,
    lng: 0,
    radius: 5,
  };
  orderbytimestampDeviceNearbyAsc: boolean = true;

  deviceNearbyMarkers: google.maps.Marker[] = [];

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });

  async initializeMap(isDeviceNearby: boolean) {
    await this.loader.importLibrary('core');
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );
    if (isDeviceNearby) {
      this.maps.addListener('click', (mapsMouseEvent: any) => {
        this.deviceNearbyMapLatLngRadius = {
          lat: mapsMouseEvent.latLng.lat(),
          lng: mapsMouseEvent.latLng.lng(),
          radius: this.deviceNearbyMapLatLngRadius.radius,
        };
        this.clickMapDeviceNearby();
      });
    }
    await this.loader.importLibrary('drawing');
    const { DrawingManager } = (await google.maps.importLibrary(
      'drawing'
    )) as google.maps.DrawingLibrary;
    const drawingOptions = {
      drawingControl: false,

      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [google.maps.drawing.OverlayType.MARKER],
      },
      markerOptions: {
        draggable: true,
      },
    };
    this.drawingManager = new DrawingManager(drawingOptions);
    console.log('');
    google.maps.event.addListener(
      this.drawingManager,
      'overlaycomplete',
      (event: any) => {
        if (event.type === google.maps.drawing.OverlayType.MARKER) {
          this.newEventoSupport.gps.value.latitude =
            event.overlay.position.lat();
          this.newEventoSupport.gps.value.longitude =
            event.overlay.position.lng();

          let proa = this.newEventoSupport.gps.value.proa
            ? this.newEventoSupport.gps.value.proa
            : undefined;
          this.createMarker(
            this.newEventoSupport.gps.value.latitude,
            this.newEventoSupport.gps.value.longitude,
            proa
          );
        }
        this.drawingManager.drawingControl = false;
        this.drawingManager.setDrawingMode(null);
        this.drawingManager.drawingControlOptions.drawingModes = [];
        this.drawingManager.setMap(this.drawingManager.map);
        this.drawingManager = this.drawingManager;
        event.overlay.setMap(null);
      }
    );
  }

  urlRdash:any;

  constructor(
    private utilService: UtilService,
    public modalService: NgbModal,
    public toastService: ToastService,
    public datePipe: DatePipe,
    httpClient: HttpClient,
    private positionService: PositionsService,
    private authService: AuthService,
    private findGatewayService: FideGatewayService,
    private elementRef: ElementRef,
    private _clipboardService: ClipboardService,
    private cdr: ChangeDetectorRef,
  ) {

    this.movidaExpressFormGroup = new FormGroup(
      {
        plate: new FormControl('', [Validators.required]),
        serialNumber: new FormControl('', [Validators.required]),
        password: new FormControl(''),
        usePasswordDefault: new FormControl(true),
      },
      {
        validators: this.validatorFn(),
      }
    );

    this.userAudit = new UserAudit(
      this.authService.currentUserValue,
      'tools/utils'
    );
    this.apiLoaded = httpClient
      .jsonp(
        `https://maps.googleapis.com/maps/api/js?key=${environment.googleMaps.key}&libraries=geometry,drawing`,
        'callback'
      )
      .pipe(
        map(() => true),
        catchError(() => of(false))
      );
    this.user = this.authService.currentUserValue;
    this.isUserAdmin = this.authService.isUserAdmin;
    this.isUserAll = this.authService.isUserAll;
    new Date().valueOf();
    /* 
  Generate Events Enums
 */
    for (const key in Object(Evento_TiposEventos)) {
      if (Number(key) || key == '0') {
        this.eventProto.tipo_evento.push({
          id: Number(key),
          name: Object(Evento_TiposEventos)[key],
        });
      }
    }
    for (const key in Object(Evento_Rastreador_Fabricante)) {
      if (Number(key) || key == '0') {
        this.eventProto.fabricante.push({
          id: Number(key),
          name: Object(Evento_Rastreador_Fabricante)[key],
        });
      }
    }
    for (const key in Object(Evento_OrigemMensagem)) {
      if (Number(key) || key == '0') {
        this.eventProto.origem_mensagem.push({
          id: Number(key),
          name: Object(Evento_OrigemMensagem)[key],
        });
      }
    }
    for (const key in Object(Evento_EstadosPortas_equipamento)) {
      if (Number(key) || key == '0') {
        this.eventProto.equipamento.push({
          id: Number(key),
          name: Object(Evento_EstadosPortas_equipamento)[key],
        });
      }
    }
    for (const key in Object(Evento_EstadosPortas_tipo)) {
      if (Number(key) || key == '0') {
        this.eventProto.tipo.push({
          id: Number(key),
          name: Object(Evento_EstadosPortas_tipo)[key],
        });
      }
    }
    for (const key in Object(Evento_EstadosPortas_estadoSaida)) {
      if (Number(key) || key == '0') {
        this.eventProto.estado_saida.push({
          id: Number(key),
          name: Object(Evento_EstadosPortas_estadoSaida)[key],
        });
      }
    }
  }
  ngOnInit(): void {
    this.newEvento.data_hora_evento = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddTHH:mm:ss'
    )!;
    this.newEvento.data_hora_recebimento = this.datePipe.transform(
      new Date().getTime() + 2000,
      'yyyy-MM-ddTHH:mm:ss'
    )!;
    this.utilService.getUF().subscribe((response: any) => {
      this.ufLst = response;
    });

    this.dateStartSendToDEV = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddT00:00:00'
    )!;
    this.dateEndSendToDEV = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddT23:59:59'
    )!;
  }

  createCSVIccid() {	
    const confirmar = confirm('Tem certeza que deseja gerar o relatório CSV de Serial vs ICCID?');
    if(confirmar) {
    this.utilService.createFileIccid(this.userAudit.usuario, this.userAudit.usuarioId).subscribe(
      (response: any) => {
        this.toastService.show('Solicitação gerada com sucesso!', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
            },
            (error: HttpErrorResponse) => {
            this.toastService.show('Erro no processamento - ' + error.message, {
                    classname: 'bg-danger text-center text-white',
                    delay: 10000,
              });
            }
        );
      }
  }

  currentPage = 1;
  itemsPerPage = 10;

  getPaginatedFiles(): any[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.files.slice(start, start + this.itemsPerPage);
  }

  get totalPages() {
    const total = Math.ceil((this.files?.length || 0) / this.itemsPerPage);
    return total > 0 ? total : 1;
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.cdr.detectChanges(); // força atualização do template
    }
  }

 requestFilesCSVIccid(): void {
  this.utilService.requestFilesIccid().subscribe({
    next: (response: any[]) => {
      this.files = response;
      if(this.files.length > 0) {
        this.toastService.show('Relatório recebido com sucesso!', {
        classname: 'bg-success text-center text-white',
        delay: 2500,
	      });
      };
    },
    error: (error: HttpErrorResponse) => {
      	this.toastService.show('Erro no processamento - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
          });
       }
  });
 }

 downloadFileCSV(id : string) {	
    this.utilService.downloadFileCSV(id).subscribe(
	blob => {
	  const url = window.URL.createObjectURL(blob);
   	  const a = document.createElement('a');
    	  a.href = url;
    	  a.download = "serialVsiccid.csv";
    	  a.click();
    	  window.URL.revokeObjectURL(url);
	});
  }

  requestConsumer() {	
    this.utilService.requestConsumerMaxtrack().subscribe(
      (response: any) => {
        this.toastService.show('Recebido com sucesso!', {
                classname: 'bg-success text-center text-white',
                delay: 2500,
              });
        this.consumer = response[0];
        },
        (error: HttpErrorResponse) => {
        this.toastService.show('Erro no processamento - ' + error.message, {
                classname: 'bg-danger text-center text-white',
                delay: 10000,
          });
        }
    );
  }

  //Dump

  getSerialDump() {
    this.circularProgressiveWaitDump = true;
    this.seriaListDump = [];
    this.utilService.getSerialDump(this.seriaisDump.trim()).subscribe(
      (response: any) => {
        response.forEach((item: any) => {
          let jsonItem = JSON.parse(item);
          jsonItem.timeRemaining = `${(jsonItem.timeRemaining / 3600).toFixed(
            1
          )} horas\n${(jsonItem.timeRemaining / 84600).toFixed(1)} dias`;
          this.seriaListDump.push(jsonItem);
        });
        this.circularProgressiveWaitDump = false;
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWaitDump = false;
      }
    );
  }

  getDump(serial: string) {
    this.utilService.getDump(serial.trim());
  }

  addSerialDump() {
    this.circularProgressiveWaitDump = true;
    this.utilService
      .addDump(this.seriaisDump.trim(), String(this.timeToDump))
      .subscribe(
        (response: any) => {
          this.getSerialDump();
        },
        (error: HttpErrorResponse) => {
          this.circularProgressiveWaitDump = false;
        }
      );
  }

  prepareTextToDump(serial: string, supplier: string) {
    this.utilService
      .prepareTextToDump(serial, supplier)
      .subscribe((response: any) => {
        this.resultPrepareToDump = response;
      });
  }
  // search Serial Cache
  getSerialCache() {
    this.circularProgressiveWaitLoraCache = true;
    this.serialLoraIdCache = {
      found: '',
      notFound: '',
    };
    let serialCacheLoraAux: string[] = this.serialCacheLora.split(';');
    if (serialCacheLoraAux[serialCacheLoraAux.length - 1] == '') {
      serialCacheLoraAux = serialCacheLoraAux.slice(
        0,
        serialCacheLoraAux.length - 1
      );
    }
    serialCacheLoraAux = serialCacheLoraAux.filter(
      (v, i, a) => a.indexOf(v) === i
    );
    this.utilService.getCacheLora(serialCacheLoraAux).subscribe(
      (response: any) => {
        this.serialLoraIdCache['found'] = response['found'].join('\r\n');
        this.serialLoraIdCache['notFound'] = response['notFound'].join('\r\n');
        this.circularProgressiveWaitLoraCache = false;
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWaitLoraCache = false;
      }
    );
  }
  insertLoraCache() {
    let loraIdSerial: string = '';
    let count = 0;
    this.insertCacheLora.forEach((item: LoraCache) => {
      if (
        item.loraId?.toString() != '' &&
        item.loraId?.toString() != item.serial
      ) {
        if (count > 0) {
          loraIdSerial = loraIdSerial + ';';
        }
        loraIdSerial = loraIdSerial + item.loraId + ',' + item.serial;
      }
      count++;
    });
    if (loraIdSerial != '') {
      this.circularProgressiveWaitLoraCache = true;
      this.utilService.insertLoRaCache(loraIdSerial).subscribe(
        (response: any) => {
          this.toastService.show('Inseridos com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.getSerialCache();
          this.circularProgressiveWaitLoraCache = false;
        },
        (error: HttpErrorResponse) => {
          //alert(error.message);
          this.toastService.show('Erro ao inserir - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWaitLoraCache = false;
        }
      );
    }
  }

  openModalLoraCache(centerDataModal: any) {
    this.insertCacheLora = [];
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
    this.circularProgressiveWaitLoraCacheModalStatus = true;
    this.utilService
      .getLoraIdStatus(this.serialLoraIdCache['notFound'].split('\r\n'))
      .subscribe((response: any) => {
        Object.keys(response).forEach((serial: any) => {
          if (response[serial] != '') {
            this.insertCacheLora.push({
              serial: serial,
              loraId: response[serial],
            });
          } else {
            this.insertCacheLora.push({
              serial: serial,
              loraId: response[serial],
            });
          }
        });
        this.circularProgressiveWaitLoraCacheModalStatus = false;
      });
  }

  addListCacheFindMy(item : string) {
    if(item == null || item == undefined || item == '') {
        this.messageListCacheFindMy = "O campo não ser vazio!"
    } else {
        var list = item.split(";")
        this.listCacheFindMy.push({
          serial: list[0],
          private_key: list[1],
          })
        if(list.length < 2){
          this.messageListCacheFindMy = "Item " + list[0] + " inserido na lista!"
        } else {
          this.messageListCacheFindMy = "Item " + list[0] + ";" + list[1] + " inserido na lista!"
        }        
    }
  }

  addListCacheFindMyLote(event : any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Pegando a primeira aba
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convertendo para JSON (array de arrays)
        const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        // Limpa o array global antes de adicionar novos dados
        this.listCacheFindMyLote = [];

        // Adiciona os valores da primeira coluna ao array global
        jsonData.slice(1).forEach((row, index) => {
        if (row[0]) {
          this.listCacheFindMyLote.push(row[0]);
          }
        });
      }
      reader.readAsArrayBuffer(file);
    }
  }

  createCacheFindMy() {
    let list = this.listCacheFindMy;
    if (list.length == 0) {
      this.messageCreatListCacheFindMy = "Lista não pode ser vazia!"
    } else {
      this.messageCreatListCacheFindMy = '';
      this.circularProgressiveWaitFindMyCache = true
      this.utilService.insertFindMyCache(list).subscribe({
        next: (response : any[]) => {
          this.responseCreateListCacheFindMy = response;
        }, 
        error : (error: HttpErrorResponse) => {
            this.toastService.show('Erro ao cadastrar - ' + error.message, {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            });
            this.circularProgressiveWaitLoraCache = false;
        },
        complete: () => { }
      })
    }
  }

  createCacheFindMyLote() {
    let list = this.listCacheFindMyLote;
    if (list.length > 0) {
      this.circularProgressiveWaitFindMyCache = true
      this.utilService.insertFindMyCacheLote(list).subscribe({
        next: (response : any[]) => {
          this.responseCreateListCacheFindMyLote = response;
        }, 
        error : (error: HttpErrorResponse) => {
            this.toastService.show('Erro ao cadastrar - ' + error.message, {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            });
            this.circularProgressiveWaitLoraCache = false;
        },
        complete: () => { }
      })
    }
  }

  pesquisarCacheFindMy() {
    let list = this.searchCacheFindMy;
    if(list != null && list != '') {
        this.utilService.searchFindMyCache(list).subscribe({
        next: (response : any[]) => {
          if(response.length > 0) {
          // Cria um novo array transformado
            let newArray = response.map(item => {
              let dataConvertida = "";
              if (item.data && item.data.trim() !== "") {
                const date = new Date(Number(item.data));
                dataConvertida = new Intl.DateTimeFormat("pt-BR", {
                  timeZone: "America/Sao_Paulo",
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit"
                }).format(date);
              }
              return {
                ...item,
                dataConvertida // será vazio se não houver data
              };
            });       
            this.responseSearchListCacheFindMy = newArray;
          }
        }, 
        error : (error: HttpErrorResponse) => {
            this.toastService.show('Erro ao pesquisar na Cache - ' + error.message, {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            });
        },
        complete: () => { }
      })
    }
  }

  removeCacheFindMy() {
      let list = this.removerCacheFindMy;
      if(list != null && list != '') {
          this.utilService.removeFindMyCacheLote(list).subscribe({
          next: (response : any[]) => {
            this.responseRemoveListCacheFindMyLote = response;
          }, 
          error : (error: HttpErrorResponse) => {
              this.toastService.show('Erro ao remover - ' + error.message, {
                classname: 'bg-danger text-center text-white',
                delay: 10000,
              });
          },
          complete: () => { }
        })
      }
  }

  /* 
  break line to ;
 */

  replaceBreakLineToDotPeriod(
    unique: boolean,
    breakLineSQL: any,
    breakLineInverted: any
  ) {
    this.breakLineToDotPeriodOutput = [];
    let lstUnique = [];
    let lst = [];
    let strJoin = breakLineSQL ? "',\n'" : ';';
    let strBreak = breakLineInverted ? strJoin : '\n';

    if (unique) {
      this.breakLineToDotPeriodInput = this.breakLineToDotPeriodInput
        .split(strBreak)
        .filter((v, i, a) => a.indexOf(v) === i)
        .join(strBreak);
    }

    lst = this.breakLineToDotPeriodInput.split(strBreak);
    lstUnique = lst.filter((v, i, a) => a.indexOf(v) === i);
    if (breakLineInverted) {
      this.breakLineToDotPeriodOutput.push(lst.join('\n'));
      if (breakLineSQL) {
        this.breakLineToDotPeriodOutput[0].replaceAll("'", '');
      }
    } else {
      this.breakLineToDotPeriodOutput.push(lst.join(strJoin));
    }

    this.breakLineToDotPeriodOutput.push(
      (lst.length - lstUnique.length).toString()
    );
    this.breakLineToDotPeriodOutput.push(lstUnique.length.toString());
  }

  /* 
  Tables ODT to LaTEX
 */
  readFile(file: any): Promise<string | null | any> {
    return new Promise((resolve, reject) => {
      let freader = new FileReader();
      freader.onload = (x) => resolve(freader.result);
      freader.readAsText(file);
    });
  }

  async selectFileTableLaTEX(event: any) {
    this.textTableLatexOut = '';
    if (event != null) {
      let a: string = await this.readFile(event.target.files[0]);

      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(a, 'text/html');
      let result: {}[] = [];
      for (
        let index = 0;
        index < htmlDoc.getElementsByTagName('table').length;
        index++
      ) {
        result.push(
          this.tableTestODTToJSON(htmlDoc.getElementsByTagName('table')[index])
        );
      }
      this.textTableLatexOut = this.JSONODTtolaTEX(result);
    }
  }

  replaceCaracterSpecial(text: string) {
    let caracteres: any = ['$', '#', '%', '^', '&', '_', '{', , '}', '~'];
    let caractere2: any = ['<', '>'];
    let textAux = text;
    textAux = textAux
      .split('\\\\')
      .join('x|||||||x')
      .replace('\\', '$\\backslash$')
      .split('x|||||||x')
      .join('\\\\');
    caracteres.forEach((item: string) => {
      textAux = textAux.split(item).join('\\' + item);
    });
    caractere2.forEach((item: string) => {
      textAux = textAux.split(item).join('$' + item + '$');
    });
    textAux = textAux.replace('\n', '\\newline');

    return textAux;
  }

  JSONODTtolaTEX(items: {}[]) {
    let lst: String[] = [];
    items.forEach((item: any) => {
      let templateTableLaTEXTAux = this.templateTableLaTEXT.join('\n');
      Object.keys(item).forEach((itemKey: any) => {
        let value = this.replaceCaracterSpecial(item[itemKey]);
        switch (itemKey) {
          case 'Caso de Teste':
            templateTableLaTEXTAux = templateTableLaTEXTAux.replace(
              '|CASO_DE_TESTE|',
              value
            );
            break;
          case 'Último Status':
            templateTableLaTEXTAux = templateTableLaTEXTAux.replace(
              '|STATUS|',
              value
            );
            break;
          case 'Sumário':
            templateTableLaTEXTAux = templateTableLaTEXTAux.replace(
              '|SUMARIO|',
              value
            );
            break;
          case 'Baseline':
            templateTableLaTEXTAux = templateTableLaTEXTAux.replace(
              '|BASELINE|',
              value
            );
            break;
          case 'Comentários':
            templateTableLaTEXTAux = templateTableLaTEXTAux.replace(
              '|COMENTARIO|',
              value
            );
            break;
          default:
            break;
        }
      });
      lst.push(templateTableLaTEXTAux);
    });
    return lst.join('\n');
  }

  tableTestODTToJSON(table: any) {
    var obj: any = {};
    var row,
      rows = table.rows;
    for (var i = 0, iLen = rows.length; i < iLen; i++) {
      row = rows[i];
      if (String(row.cells[0].textContent).startsWith('Caso de Teste')) {
        obj['Caso de Teste'] = String(row.cells[0].textContent).replace(
          'Caso de Teste',
          ''
        );
        continue;
      } else if (
        String(row.cells[0].textContent).startsWith('Último Status:')
      ) {
        try {
          obj['Último Status'] = String(row.cells[1].textContent);
        } catch (error) {
          obj['Último Status'] = String(row.cells[0].textContent).replace(
            'Último Status:',
            ''
          );
        }
        continue;
      } else if (String(row.cells[0].textContent).startsWith('Sumário:')) {
        try {
          obj['Sumário'] = String(row.cells[1].textContent);
        } catch (error) {
          obj['Sumário'] = String(row.cells[0].textContent).replace(
            'Sumário::',
            ''
          );
        }

        continue;
      } else if (String(row.cells[0].textContent).startsWith('Baseline')) {
        try {
          obj['Baseline'] = String(row.cells[1].textContent);
        } catch (error) {
          obj['Baseline'] = String(row.cells[0].textContent).replace(
            'Baseline',
            ''
          );
        }

        continue;
      } else if (String(row.cells[0].textContent).startsWith('Comentários')) {
        try {
          obj['Comentários'] = String(row.cells[1].textContent);

          continue;
        } catch (error) {
          obj['Comentários'] = String(row.cells[0].textContent).replace(
            'Comentários',
            ''
          );
        }
        continue;
      }
    }
    return obj;
  }

  /* 
  Generate Events
 */

  generateEvent() {
    for (const key in Object(this.newEventoSupport)) {
      if (Object(this.newEventoSupport)[key].use) {
        if (key == 'bateria_interna') {
          if (Object(this.newEvento.rastreador)[key] == undefined) {
            Object(this.newEvento.rastreador)[key] = new NewEventoBateria();
          }
          Object(this.newEvento.rastreador)[key] = Object(
            this.newEventoSupport
          )[key].value;
        } else {
          Object(this.newEvento)[key] = Object(this.newEventoSupport)[
            key
          ].value;
        }
      }
    }

    let json = JSON.stringify(this.newEvento);
    json = json.replace(
      String(`data_hora_evento":"${this.newEvento.data_hora_evento}`),
      `data_hora_evento":"${String(
        new Date(this.newEvento.data_hora_evento).getTime()
      )}`
    );
    json = json.replace(
      String(`data_hora_recebimento":"${this.newEvento.data_hora_recebimento}`),
      `data_hora_recebimento":"${String(
        new Date(this.newEvento.data_hora_recebimento).getTime()
      )}`
    );

    this.utilService.generateEvent(json).subscribe(
      (response: any) => {
        this.eventResult.push({ status: 1, packet: response[0] });
        this.toastService.show('Evento gerado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
      },
      (error: HttpErrorResponse) => {
        this.eventResult.push({ status: -1, packet: error.message });

        this.toastService.show('Erro ao gerar evento- ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  changeValueButtonToggle(item: any) {
    item.use = !item.use;
  }

  changeValueButtonToggleValue(item: any, buttonValue: any, field: string) {
    switch (field) {
      case 'ativa':
        item.ativa = buttonValue._checked;
        break;
      case 'fixado':
        item.fixado = buttonValue._checked;
        break;
      default:
        break;
    }
  }

  createMarker(lat: number, lng: number, proa: number | undefined) {
    var icon = {
      path:
        proa && proa > -1
          ? google.maps.SymbolPath.FORWARD_CLOSED_ARROW
          : google.maps.SymbolPath.CIRCLE,
      fillColor: '#1e90ff',
      fillOpacity: 0.9,
      strokeWeight: 0.8,
      rotation: proa ? proa : 0,
      scale: proa ? (proa > -1 ? 3 : 5) : 5,
    };
    const marker = new google.maps.Marker({
      position: {
        lat: lat,
        lng: lng,
      },
      icon: icon,
      title: ``,
      draggable: true,
    });

    /* marker.addListener('click', () => {
    infowindow.open({
      anchor: marker,
      shouldFocus: false,
    });
  });*/
    marker.setMap(this.maps);
    this.marker = marker;
    this.maps.setCenter(new google.maps.LatLng({ lat: lat, lng: lng }));
    if (this.maps.getZoom() < 13) {
      this.maps.setZoom(15);
    }
    google.maps.event.addListener(this.marker, 'dragend', (evt: any) => {
      this.newEventoSupport.gps.value.latitude = evt.latLng.lat();
      this.newEventoSupport.gps.value.longitude = evt.latLng.lng();
    });
  }

  addMarker() {
    if (this.newEventoSupport.gps.use) {
      this.drawingManager.drawingControl = true;
      this.drawingManager.setDrawingMode(
        google.maps.drawing.OverlayType.MARKER
      );
      this.drawingManager.setMap(this.maps);
    } else {
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.drawingManager.drawingControl = false;
      this.drawingManager.setDrawingMode(null);
      this.drawingManager.drawingControlOptions.drawingModes = [];
      this.drawingManager.setMap(this.drawingManager.map);
      this.drawingManager = this.drawingManager;
    }
  }
  changeMarker() {
    let lat = Number(
      String(this.newEventoSupport.gps.value.latitude).replace(',', '.')
    );
    let lgn = Number(
      String(this.newEventoSupport.gps.value.longitude).replace(',', '.')
    );
    let proa = this.newEventoSupport.gps.value.proa
      ? this.newEventoSupport.gps.value.proa
      : undefined;

    try {
      this.marker.setMap(null);
      this.createMarker(lat, lgn, proa);
    } catch (error) {}
  }

  changeDateTimeGenerateEvent(operator: any, seconds: number) {
    let ms = seconds * 1000;
    if (seconds == -1) {
      this.newEvento.data_hora_evento = this.datePipe.transform(
        new Date(),
        'yyyy-MM-ddTHH:mm:ss'
      )!;
      this.newEvento.data_hora_recebimento = this.datePipe.transform(
        new Date(),
        'yyyy-MM-ddTHH:mm:ss'
      )!;
    } else {
      switch (
        operator._checked ? operator.checkedLabel : operator.uncheckedLabel
      ) {
        case 'Mais':
          this.newEvento.data_hora_evento = this.datePipe.transform(
            new Date(Date.parse(String(this.newEvento.data_hora_evento)) + ms),
            'yyyy-MM-ddTHH:mm:ss'
          )!;
          this.newEvento.data_hora_recebimento = this.datePipe.transform(
            new Date(
              new Date(
                Date.parse(String(this.newEvento.data_hora_recebimento)) + ms
              )
            ),
            'yyyy-MM-ddTHH:mm:ss'
          )!;
          break;
        case 'Menos':
          this.newEvento.data_hora_evento = this.datePipe.transform(
            new Date(Date.parse(String(this.newEvento.data_hora_evento)) - ms),
            'yyyy-MM-ddTHH:mm:ss'
          )!;
          this.newEvento.data_hora_recebimento = this.datePipe.transform(
            new Date(
              new Date(
                Date.parse(String(this.newEvento.data_hora_recebimento)) - ms
              )
            ),
            'yyyy-MM-ddTHH:mm:ss'
          )!;
          break;
        default:
          break;
      }
    }
  }
  getCity(uf: any) {
    this.cityLst = [];
    if (uf != undefined) {
      this.circularProgressiveCity = true;

      this.utilService
        .getCity(uf.$ngOptionLabel.trim())
        .subscribe((response: any) => {
          response.forEach((item: any) => {
            let itemSplit = item.split(';');
            this.cityLst.push({
              name: itemSplit[0],
              lat: itemSplit[1],
              lng: itemSplit[2],
            });
            this.circularProgressiveCity = false;
          });
        });
    } else {
      this.cityLst = [];
    }
  }
  changeMapOnChangeCity(city: string) {
    if (city != undefined) {
      let cityAux = this.cityLst.filter((item: any) => {
        return city == item.name;
      });
      this.maps.setCenter(
        new google.maps.LatLng({
          lat: Number(cityAux[0].lat),
          lng: Number(cityAux[0].lng),
        })
      );
      this.maps.setZoom(10);
    }
  }

  //Send to DEV
  sendToDEV() {
    this.circularProgressiveWaitSendToDEV = true;
    var dateStartEpoch = Date.parse(this.dateStartSendToDEV).toString();
    var dateEndEpoch = Date.parse(this.dateEndSendToDEV).toString();
    this.userAudit.tela = this.userAudit.tela + '/sendToDEV';
    this.positionService
      .getPositionJson(
        this.serialSendToDEV.trim(),
        dateStartEpoch,
        dateEndEpoch,
        this.userAudit
      )
      .subscribe(
        (response: any) => {
          let raws: string[] = [];
          if (response != null) {
            var positionEvent = response;
            if (positionEvent.length > 0) {
              positionEvent
                .slice()
                .reverse()
                .forEach((event: any) => {
                  try {
                    if (
                      event.raw_package != '' &&
                      event.raw_package != undefined
                    ) {
                      raws.push(event.raw_package);
                    }
                  } catch (error) {}
                });
            }
          }
          if (raws.length > 0) {
            this.utilService
              .sendPacketsToDEV(raws, this.sendToDevPort)
              .subscribe(
                (response: any) => {
                  this.toastService.show('Enviado com sucesso para DEV', {
                    classname: 'bg-success text-center text-white',
                    delay: 2500,
                  });
                },
                (error: HttpErrorResponse) => {
                  //alert(error.message);
                  this.toastService.show(
                    'Erro ao enviar pacotes - ' + error.message,
                    {
                      classname: 'bg-danger text-center text-white',
                      delay: 10000,
                    }
                  );
                  this.circularProgressiveWaitSendToDEV = false;
                }
              );
          } else {
            this.toastService.show('Sem raw_packages para ser enviado', {
              classname: 'bg-warning text-center text-white',
              delay: 10000,
            });
          }
          this.circularProgressiveWaitSendToDEV = false;
        },
        (error: HttpErrorResponse) => {
          //alert(error.message);
          this.toastService.show('Erro ao enviar pacotes - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWaitSendToDEV = false;
        }
      );
  }
  //End Send to DEV

  searchGateway() {
    this.circularProgressiveWaitSearchGateway = true;
    this.gateways = [];
    var serialList: string[] = this.gatewaysSeriais.replace(' ', '').split(';');
    serialList = serialList.filter((v, i, a) => a.indexOf(v) === i);

    this.findGatewayService.getFindGateway(serialList).subscribe(
      (response: any) => {
        response.forEach((item: any) => {
          var args = item.split(';');
          let serial = args[0];
          let ip = args[1];
          if (ip != 'null') {
            let date = args[2];
            let timestamp = Number(date);
            let diff = Math.abs(
              new Date().getTime() - new Date(timestamp).getTime()
            );
            date = this.datePipe.transform(
              new Date(Number(date)).toUTCString(),
              'dd-MM-yyyy HH:mm:ss'
            );

            var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            this.gateways.push({
              serial: serial,
              gateway: ip,
              date: date ? date : '',
              dateOrderBy: new Date(timestamp),
              dateWithoutConection:
                (new Date().getDate() == new Date(timestamp).getDate()
                  ? '0'
                  : diffDays.toString()) + ' dias desde a última conexão',
            });
          } else {
            this.gateways.push({
              serial: serial,
              gateway: 'Não encontrado',
              date: 'Não encontrado',
              dateOrderBy: new Date(1),
              dateWithoutConection: '',
            });
          }
        });
        this.circularProgressiveWaitSearchGateway = false;
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWaitSearchGateway = false;
        this.toastService.show('Erro ao pesquisar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }
  sortItem(item: Gateway[]) {
    return item.sort(
      (objA, objB) => objB.dateOrderBy.getTime() - objA.dateOrderBy.getTime()
    );
  }

  getNamePEG(item: PEGinterface[], id: Number) {
    let filter = item.filter((itemAux: PEGinterface) => {
      return itemAux.code == id;
    });
    if (filter.length > 0) {
      return filter[0].name;
    } else {
      return id;
    }
  }

  //PEG
  setAnalyze(
    modifier: number,
    param: string,
    name: string,
    searchName: string,
    type: string,
    PEGAnalytics: any
  ) {
    if (String(name).toLowerCase().search(searchName) > 0) {
      let index = PEGAnalytics.findIndex((item: any) => {
        return item.hasOwnProperty(
          `${
            searchName == 'flag' ? 'F' : searchName == 'peg' ? 'P' : 'A'
          }-${modifier}`
        );
      });
      if (index > -1) {
        Object(PEGAnalytics[index])[
          `${
            searchName == 'flag' ? 'F' : searchName == 'peg' ? 'P' : 'A'
          }-${modifier}`
        ].push(`(${type}) ${param}-${name}`);
        return PEGAnalytics;
      } else {
        PEGAnalytics.push({
          [`${
            searchName == 'flag' ? 'F' : searchName == 'peg' ? 'P' : 'A'
          }-${modifier}`]: [`(${type}) ${param}-${name}`],
        });
        return PEGAnalytics;
      }
    } else {
      return PEGAnalytics;
    }
  }
  getKey(item: any) {
    return Object.keys(item)[0];
  }
  getValue(item: any) {
    let key = Object.keys(item)[0];
    return Object(item)[key];
  }
  async renderMermaid(index: number, text: string) {
    let element = document.getElementById(`diagram`);
    if (element) {
      const { svg, bindFunctions } = await mermaid.default.render(
        `diagram${index}`,
        text
      );
      element.innerHTML = svg;
    }
  }

  async verifySyntaxMermaid(text: string) {
    return await mermaid.default.parse(text);
  }

  async parsePEG(event: any) {
    this.PEGAnalytic = { Accumulators: [], Flags: [], Pegs: [] };
    this.PEGMemaidAux = [];
    this.circularProgressiveWaitPEGMermaid = true;
    let diagramDefinition: string[] = [`graph LR; \n`];
    let diagramIndex = 0;
    try {
      let items = event.value.split('\n');
      let lstAux: string[] = [];
      items.forEach((item: any) => {
        if (item != '') {
          let aux = item.split(',');
          let peg: PEGFlow = new PEGFlow();
          if (aux[0].trim() == 512 || aux[0].trim() == 513) {
            peg.param = aux[0].trim();
            peg.paramIndex = aux[1].trim();

            const data: string = aux[2].trim();

            peg.trigger = parseInt(data.slice(0, 2), 16);

            if (peg.trigger === 0) {
              peg.triggerModifier = 0;
            } else {
              peg.triggerModifier = parseInt(data.slice(2, 4), 16);
            }

            peg.condition1 = parseInt(data.slice(4, 6), 16);

            if (peg.condition1 === 0) {
              peg.condition1Modifier = 0;
            } else {
              peg.condition1Modifier = parseInt(data.slice(6, 8), 16);
            }

            peg.action = parseInt(data.slice(8, 10), 16);

            if (peg.action === 0) {
              peg.actionModifier = 0;
            } else {
              peg.actionModifier = parseInt(data.slice(10, 12), 16);
            }

            peg.condition2 = parseInt(data.slice(12, 14), 16);

            if (peg.condition2 === 0) {
              peg.condition2Modifier = 0;
            } else {
              peg.condition2Modifier = parseInt(data.slice(14, 16), 16);
            }
            let len7 = 0;
            let len8 = 0;
            let binary = parseInt(data.slice(12, 14), 16).toString(2);
            if (binary.length == 7) {
              len7 = parseInt(binary.slice(0, 1), 2);
            }
            if (binary.length == 8) {
              len8 = parseInt(binary.slice(0, 2), 2);
            }

            if (len8 == 3 || len8 == 1 || len7 == 1) {
              peg.logicalCondition2 = 'OR';
            } else if (peg.condition2 > 0) {
              peg.logicalCondition2 = 'AND';
            }
            if (peg.logicalCondition2 == 'OR') {
              peg.condition2 = peg.condition2 - 64;
            }

            let param = `${peg.param}.${peg.paramIndex}`;

            if (peg.trigger == 0) {
              lstAux.push(`${param}[${param}] --> T${param}[Não ativo];`);
            } else {
              let triggerName = String(
                this.getNamePEG(this.PEGDetails.triggers, Number(peg.trigger))
              );
              let condition1Name = String(
                this.getNamePEG(
                  this.PEGDetails.conditions,
                  Number(peg.condition1)
                )
              );
              let condition2Name = String(
                this.getNamePEG(
                  this.PEGDetails.conditions,
                  Number(peg.condition2)
                )
              );
              let actionName = String(
                this.getNamePEG(this.PEGDetails.actions, Number(peg.action))
              );
              lstAux.push(
                `${param}[${param}] --> T${param}[${
                  this.PEGFlagUseWHENIFTHENNomeclature ? 'QUANDO' : ''
                } ${triggerName} - ${peg.triggerModifier} ] --> C1_${param}[${
                  this.PEGFlagUseWHENIFTHENNomeclature ? 'SE' : ''
                } ${condition1Name} - ${
                  peg.condition1Modifier
                } ] --> C2_${param}[${
                  peg.logicalCondition2
                } ${condition2Name}  - ${
                  peg.condition2Modifier
                } ] --> A_${param}[${
                  this.PEGFlagUseWHENIFTHENNomeclature ? 'ENTÃO' : ''
                } ${actionName} - ${
                  actionName.toLowerCase() == 'return' ? '' : peg.actionModifier
                }];`
              );
              //Accumulators

              peg.trigger > 0
                ? (this.PEGAnalytic.Accumulators = this.setAnalyze(
                    peg.triggerModifier,
                    param,
                    triggerName,
                    'accumulator',
                    'T',
                    this.PEGAnalytic.Accumulators
                  ))
                : null;

              peg.condition1 > 0
                ? (this.PEGAnalytic.Accumulators = this.setAnalyze(
                    peg.condition1Modifier,
                    param,
                    condition1Name,
                    'accumulator',
                    'C1',
                    this.PEGAnalytic.Accumulators
                  ))
                : null;

              peg.condition2 > 0
                ? (this.PEGAnalytic.Accumulators = this.setAnalyze(
                    peg.condition2Modifier,
                    param,
                    peg.logicalCondition2 + ' ' + condition2Name,
                    'accumulator',
                    'C2',
                    this.PEGAnalytic.Accumulators
                  ))
                : null;

              peg.action > 0
                ? (this.PEGAnalytic.Accumulators = this.setAnalyze(
                    peg.actionModifier,
                    param,
                    actionName,
                    'accumulator',
                    'A',
                    this.PEGAnalytic.Accumulators
                  ))
                : null;
              //flags
              peg.trigger > 0
                ? (this.PEGAnalytic.Flags = this.setAnalyze(
                    peg.triggerModifier,
                    param,
                    triggerName,
                    'flag',
                    'T',
                    this.PEGAnalytic.Flags
                  ))
                : null;
              peg.condition1 > 0
                ? (this.PEGAnalytic.Flags = this.setAnalyze(
                    peg.condition1Modifier,
                    param,
                    condition1Name,
                    'flag',
                    'C1',
                    this.PEGAnalytic.Flags
                  ))
                : null;
              peg.condition2 > 0
                ? (this.PEGAnalytic.Flags = this.setAnalyze(
                    peg.condition2Modifier,
                    param,
                    peg.logicalCondition2 + ' ' + condition2Name,
                    'flag',
                    'C2',
                    this.PEGAnalytic.Flags
                  ))
                : null;
              peg.action > 0
                ? (this.PEGAnalytic.Flags = this.setAnalyze(
                    peg.actionModifier,
                    param,
                    actionName,
                    'flag',
                    'A',
                    this.PEGAnalytic.Flags
                  ))
                : null;
              //Pegs
              peg.condition1 > 0
                ? (this.PEGAnalytic.Pegs = this.setAnalyze(
                    peg.condition1Modifier,
                    param,
                    condition1Name,
                    'peg',
                    'C',
                    this.PEGAnalytic.Pegs
                  ))
                : null;

              peg.condition2 > 0
                ? (this.PEGAnalytic.Pegs = this.setAnalyze(
                    peg.condition2Modifier,
                    param,
                    peg.logicalCondition2 + ' ' + condition2Name,
                    'peg',
                    'C2',
                    this.PEGAnalytic.Pegs
                  ))
                : null;
            }

            this.PEGFlow.push(peg);
          }
        }
      });

      diagramDefinition[diagramIndex] =
        diagramDefinition[diagramIndex] + lstAux.join('\n');

      lstAux = [];
      let callId = 51;
      let jumpId = 50;
      let returnId = 52;
      let end = 53;
      let lstAuxLength = 0;
      let notAddMore = 0;
      let onceTimeExpired = 255;
      let lastCallIndex = 0;

      for (let index = 0; index < this.PEGFlow.length; index++) {
        let peg = this.PEGFlow[index];
        let param = `${peg.param}.${peg.paramIndex}`;
        let actionAux = `A_${param} --> ${peg.param}.${
          Number(peg.paramIndex) + 1
        };`;
        if (!lstAux.includes(actionAux)) {
          let aux = `${peg.action}${peg.condition1}${peg.condition2}${peg.action}`;
          if (
            aux != `4800${returnId}` &&
            aux != `4800${callId}` &&
            aux != `4800${end}` &&
            aux != `4800${jumpId}`
          ) {
            lstAux.push(actionAux);
          }
        }
      }

      for (let index = 0; index < this.PEGFlow.length; index++) {
        let peg = this.PEGFlow[index];

        if (lstAuxLength == lstAux.length) {
          notAddMore = notAddMore + 1;
        }

        lstAuxLength = lstAux.length;

        let param = `${peg.param}.${peg.paramIndex}`;
        // console.log(`index ${index} - param ${param}`);
        if (notAddMore > onceTimeExpired) {
          break;
        }
        let indexAux = 0;
        let actionAux = '';
        switch (peg.action) {
          case callId:
            lastCallIndex = index;
            actionAux = `A_${param} --> |Call ${param} para ${peg.param}.${peg.actionModifier}| ${peg.param}.${peg.actionModifier};`;
            if (!lstAux.includes(actionAux)) {
              lstAux.push(actionAux);
              indexAux = this.PEGFlow.findIndex((item: PEGFlow) => {
                return (
                  `${item.param}.${item.paramIndex}` ==
                  `${peg.param}.${peg.actionModifier}`
                );
              });
            }
            // console.log(
            //   `Call indexAux: ${indexAux} from:${param} to:${actionAux}`
            // );
            if (indexAux > -1) {
              index = indexAux - 1;
            }
            break;
          case returnId:
            actionAux = `A_${param} --> |Return ${param} para ${this.PEGFlow[lastCallIndex].param}.${this.PEGFlow[lastCallIndex].paramIndex}| ${this.PEGFlow[lastCallIndex].param}.${this.PEGFlow[lastCallIndex].paramIndex};`;
            // console.log(
            //   `Return indexAux: ${indexAux} from:${param} to:${actionAux}`
            // );
            if (!lstAux.includes(actionAux)) {
              lstAux.push(actionAux);
              if (peg.actionModifier == 0) {
                index = lastCallIndex;
                // console.log(`Return index ${index} - ${lastCallIndex}`);
              }
            }
            break;
          default:
            break;
        }
      }
      // Connection Call Aux
      for (let index = 0; index < this.PEGFlow.length; index++) {
        let peg = this.PEGFlow[index];
        let param = `${peg.param}.${peg.paramIndex}`;
        if (callId == peg.action) {
          let actionAux = `A_${param} --> |Call ${param} para ${peg.param}.${peg.actionModifier}| ${peg.param}.${peg.actionModifier};`;
          if (!lstAux.includes(actionAux)) {
            lstAux.push(actionAux);
          }
        }
      }
      for (let index = 0; index < this.PEGFlow.length; index++) {
        let peg = this.PEGFlow[index];
        let param = `${peg.param}.${peg.paramIndex}`;
        if (jumpId == peg.action) {
          let actionAux = `A_${param} --> |Jump ${param} para ${peg.param}.${peg.actionModifier}| ${peg.param}.${peg.actionModifier};`;
          if (!lstAux.includes(actionAux)) {
            lstAux.push(actionAux);
          }
        }
      }

      diagramDefinition[diagramIndex] =
        diagramDefinition[diagramIndex] + '\n' + lstAux.join('\n');

      mermaid.default.init({ startOnLoad: true });
      for (let index = 0; index < diagramDefinition.length; index++) {}

      diagramIndex = 0;
      this.PEGMemaidAux = diagramDefinition;
      for (let index = 0; index < diagramDefinition.length; index++) {
        await this.renderMermaid(index, diagramDefinition[diagramIndex]);
      }

      let element = document.querySelector(
        '[aria-roledescription="flowchart-v2"]'
      );
      element?.setAttribute('height', '600px');

      // const svgElement = this.elementRef.nativeElement.querySelector('svg');

      // svgPanZoom(svgElement, {
      //   zoomEnabled: true,
      //   controlIconsEnabled: true,
      //   fit: true,
      //   center: true,
      //   maxZoom: 40,
      // });
      this.circularProgressiveWaitPEGMermaid = false;
    } catch (error) {
      console.log(error);
      this.circularProgressiveWaitPEGMermaid = false;
    }
  }

  //ParserAux
  filterBreakPacket(item: ParserPacket): ParserPacket {
    let itemFilter: ParserPacket = JSON.parse(JSON.stringify(item));
    let indexGroup: any[] = [];
    let indexParam: any[] = [];
    let indexFilter: any[] = [];
    if (item.filterGroup.length > 0) {
      item.filterGroup.forEach((itemFilterSelect: string) => {
        item.paramGroup.forEach((itemGroup: string, index) => {
          if (itemGroup == itemFilterSelect) {
            indexGroup.push(index);
          }
        });
      });
    }
    if (item.filterParam.length > 0) {
      item.filterParam.forEach((itemFilterSelect: string) => {
        item.param.forEach((itemParam: string, index) => {
          if (itemParam == itemFilterSelect) {
            indexParam.push(index);
          }
        });
      });
    }
    indexGroup = indexGroup.concat(indexParam);
    indexGroup = indexGroup.filter((v, i, a) => a.indexOf(v) === i);
    if (item.filterGroup.length > 0) {
      indexFilter = indexGroup;
    }
    if (item.filterParam.length > 0) {
      indexFilter = indexParam;
    }
    if (indexFilter.length > 0) {
      itemFilter.paramGroup = indexFilter.map(
        (index) => item.paramGroup[index]
      );
      itemFilter.param = indexFilter.map((index) => item.param[index]);
      itemFilter.value.forEach((itemAux: any[], i) => {
        itemFilter.value[i] = indexFilter.map((index) => itemAux[index]);
      });
    }

    return itemFilter;
  }

  returnDistinct(item: any[]) {
    return item.filter((v, i, a) => a.indexOf(v) === i);
  }

  removeItemPacket(indexParser: number, indexValue: number) {
    try {
      this.parser.parserPacket[indexParser].value.splice(indexValue, 1);
      this.parser.parserPacket[indexParser].packet.splice(indexValue, 1);
    } catch (e) {}
    if (this.parser.parserPacket[indexParser].value.length == 0) {
      this.parser.parserPacket[indexParser].value = [['']];
      this.parser.parserPacket[indexParser].packet = [];
    }
  }

  breakPacket(item: any) {
    let value = [];
    let valueLst: string[] = [];
    let sep = this.parser.parserPacket[0].sep;
    let headerSep = this.parser.parserPacket[0].headerSep;
    this.parser.parserPacket[0].packet.push(item.value);
    if (this.parser.parserPacket[0].paramGroup[0] != 'PACOTE') {
      this.parser.parserPacket[0].paramGroup = ['PACOTE'].concat(
        this.parser.parserPacket[0].paramGroup
      );
      this.parser.parserPacket[0].param = ['PACOTE'].concat(
        this.parser.parserPacket[0].param
      );
    }

    if (headerSep != null) {
      let valueAux = item.value.split(headerSep);
      valueLst = [valueAux[0]];
      value = valueAux[1];
    }
    if (value.length > 0) {
      let valueAux = value.split(sep);
      valueLst = valueLst.concat(valueAux);
    } else {
      valueLst = item.value.split(sep);
    }
    if (this.parser.parserPacket[0].value[0].length == 1) {
      this.parser.parserPacket[0].value[0] = valueLst;
      this.parser.parserPacket[0].value[0] = [item.value].concat(
        this.parser.parserPacket[0].value[0]
      );
    } else {
      this.parser.parserPacket[0].value.push(valueLst);
      this.parser.parserPacket[0].value[
        this.parser.parserPacket[0].value.length - 1
      ] = [item.value].concat(
        this.parser.parserPacket[0].value[
          this.parser.parserPacket[0].value.length - 1
        ]
      );
    }
  }

  copyToClipboard(item: any, showMessage: boolean = true): void {
    try {
      this._clipboardService.copy(item);
      if (showMessage)
        this.toastService.show('Copiado para a área de transferência', {
          classname: 'bg-success text-center text-white',
          delay: 25000,
        });
    } catch (error: any) {
      this.toastService.show('Erro ao copiar', {
        classname: 'bg-danger text-center text-white',
        delay: 10000,
      });
    }
  }

  searchDeviceNearby(lat: any, lng: any, radius: any) {
    this.utilService.deviceNearby(lat, lng, radius).subscribe({
      next: (response: any) => {
        if (response != undefined) {
          let devicesAux: DeviceNearbyItem[] = [];
          response.devices.forEach((item: string) => {
            devicesAux.push(new DeviceNearbyItem(item));
          });
          this.deviceNearby = response;
          this.deviceNearby.devices = devicesAux;
          this.deviceNearbyFilter.devices = this.deviceNearby.devices;
          this.filterDeviceNearby();
        }
      },
      error: (error: any) => {
        console.log();
      },
    });
  }
  decodeTimestamp(timestamp: any) {
    try {
      return this.datePipe.transform(
        new Date(Number(timestamp)).toUTCString(),
        'dd-MM-yyyy HH:mm:ss'
      )!;
    } catch (error) {
      return '';
    }
  }
  filterDeviceNearby() {
    if (this.deviceNearbyMarkers.length > 0) {
      this.deviceNearbyMarkers.forEach((itemMarker: any) => {
        itemMarker.setMap(null);
      });
    }

    this.deviceNearbyFilter.devices = this.deviceNearby.devices;
    if (this.deviceNearbyFilter.deviceManufactorDistinct.length > 0) {
      this.deviceNearbyFilter.devices = this.deviceNearbyFilter.devices.filter(
        (item: DeviceNearbyItem) =>
          this.deviceNearbyFilter.deviceManufactorDistinct.includes(
            item.manufactor
          )
      );
    }
    if (this.deviceNearbyFilter.deviceMessageOriginDistinct.length > 0) {
      this.deviceNearbyFilter.devices = this.deviceNearbyFilter.devices.filter(
        (item: DeviceNearbyItem) =>
          this.deviceNearbyFilter.deviceMessageOriginDistinct.includes(
            item.messageOrigin
          )
      );
    }
    if (this.deviceNearbyFilter.deviceEventTypeDistinct.length > 0) {
      this.deviceNearbyFilter.devices = this.deviceNearbyFilter.devices.filter(
        (item: DeviceNearbyItem) =>
          this.deviceNearbyFilter.deviceEventTypeDistinct.includes(
            item.eventType
          )
      );
    }
    if (this.deviceNearbyFilter.deviceModelDistinct.length > 0) {
      this.deviceNearbyFilter.devices = this.deviceNearbyFilter.devices.filter(
        (item: DeviceNearbyItem) =>
          this.deviceNearbyFilter.deviceModelDistinct.includes(item.deviceModel)
      );
    }
    this.deviceNearbyFilter.devices.forEach((deviceItem: DeviceNearbyItem) => {
      this.setMakerPosition(deviceItem);
    });
  }
  clickMapDeviceNearby() {
    if (this.deviceNearbyMapLatLngMarker) {
      this.deviceNearbyMapLatLngMarker.setMap(null);
    }
    if (
      this.deviceNearbyMapLatLngRadius.lat != 0 &&
      this.deviceNearbyMapLatLngRadius.lng != 0
    ) {
      const markerCircle = new google.maps.Circle({
        center: new google.maps.LatLng({
          lat: this.deviceNearbyMapLatLngRadius.lat,
          lng: this.deviceNearbyMapLatLngRadius.lng,
        }),

        radius: this.deviceNearbyMapLatLngRadius.radius * 1000,
        draggable: true,
        strokeColor: '#3e1451',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FFFFFF',
        fillOpacity: 0.35,
      });

      markerCircle.addListener('dragend', (mapsMouseEvent: any) => {
        this.deviceNearbyMapLatLngRadius = {
          lat: markerCircle.getCenter()?.lat() ?? 0,
          lng: markerCircle.getCenter()?.lng() ?? 0,
          radius: this.deviceNearbyMapLatLngRadius.radius,
        };
      });

      this.maps.setCenter(markerCircle.getCenter());
      this.maps.setZoom(11);
      this.deviceNearbyMapLatLngMarker = markerCircle;
      this.deviceNearbyMapLatLngMarker.setMap(this.maps);
    }
  }
  setMakerPosition(item: DeviceNearbyItem) {
    if (item.geoLocation != null) {
      var geoLocation = item.geoLocation.split(',');
      var lat = geoLocation[0];
      var lng = geoLocation[1];
      var color = 'blue';

      if (item.positionOnline) {
        if (item.gpsFixed) {
          color = 'blue';
        } else {
          color = 'black';
        }
      } else if (item.gpsFixed) {
        color = 'red';
      } else {
        color = 'purple';
      }
      let proa = item.gpsAngle;
      let icon = '';
      if (proa == -1) {
        icon = `../../../../assets/images/arrows/${color}_circle.png`;
      } else {
        if (Number(item.gpsAngle) < 0 || Number(item.gpsAngle) > 360) {
          proa = 0;
        }
        icon = `../../../../assets/images/arrows/${color}_arrow_${String(
          Number(proa).toFixed(0)
        )}.png`;
      }

      let marker: any;
      let infowindow: any;
      if (item.messageOrigin == 'LORA_P2P') {
        marker = new google.maps.Marker({
          position: {
            lat: Number(item.p2p_latitude),
            lng: Number(item.p2p_longitude),
          },
          icon: '../../../../assets/images/carrinho-p2p.png',
          title: `<p><span style="color: #ff0000;"><strong>${item.datetimeEvent}</strong></span></p>`,
          // label: `${this.positionEventJson.length + 1}`,
        });

        infowindow = new google.maps.InfoWindow({
          content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span"><strong>${item.serialNumber}</strong></span></p>
        <p><span style="color: #ff0000;"><strong>${
          item.datetimeEvent
        }</strong></span></p>
        <p><strong>Evento:</strong> ${item.p2p_reason ?? ''}</p>
        <p><strong>Rssi:</strong> ${item.p2p_rssi ?? ''}</p>
        <p><strong>SNR:</strong> ${item.p2p_snr ?? ''}</p>
        <p><strong>Lat:</strong> ${item.p2p_latitude}</p>
        <p><strong>Long:</strong> ${item.p2p_longitude}</p>
        <p><strong>Dispositivo que detectou:</strong> ${
          item.p2p_serialNumber ?? ''
        }</p>
        <p><strong>OrigemMensagem:</strong> ${item.messageOrigin ?? ''}</p>
        </div>
        `,
        });
      } else if (item.messageOrigin == 'LORA_WAN') {
        marker = new google.maps.Marker({
          position: {
            lat: Number(item.p2p_latitude),
            lng: Number(item.p2p_longitude),
          },
          icon: '../../../../assets/images/tower.png',
          title: `<p><span style="color: #ff0000;"><strong>${item.datetimeEvent}</strong></span></p>`,
        });

        infowindow = new google.maps.InfoWindow({
          content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span"><strong>${item.serialNumber}</strong></span></p>
        <p><span style="color: #ff0000;"><strong>${
          item.datetimeEvent
        }</strong></span></p>
        <p><strong>Evento:</strong> ${item.p2p_reason ?? ''}</p>
        <p><strong>Rssi:</strong> ${item.p2p_rssi ?? ''}</p>
        <p><strong>SNR:</strong> ${item.p2p_snr ?? ''}</p>
        <p><strong>Lat:</strong> ${item.p2p_latitude}</p>
        <p><strong>Long:</strong> ${item.p2p_longitude}</p>
        <p><strong>OrigemMensagem:</strong> ${item.messageOrigin ?? ''}</p>
        </div>
        `,
        });
      } else {
        marker = new google.maps.Marker({
          position: {
            lat: Number(lat),
            lng: Number(lng),
          },
          icon: { url: icon, anchor: new google.maps.Point(12, 12) },
          title: `<p><span style="color: #ff0000;"><strong>${item.datetimeEvent}</strong></span></p>`,
          // label: `${this.positionEventJson.length + 1}`,
          optimized: true,
        });

        infowindow = new google.maps.InfoWindow({
          content: ` <div style="line-height: 0.5;">
        <br></br>
        <p><span"><strong>${item.serialNumber}</strong></span></p>
        <p><span style="color: #ff0000;"><strong>${item.serialNumber}</strong></span></p>
        <p><strong>Evento:</strong> ${item.eventType}</p>
        <p><strong>Lat:</strong> ${lat}</p>
        <p><strong>Long:</strong> ${lng}</p>
        <p><strong>GpsFix:</strong> ${item.gpsFixed}</p>
        <p><strong>PosicaoOnline:</strong>${item.positionOnline}</p>
        <p><strong>Velocidade:</strong> ${item.gpsSpeed}</p>
        </div>
        `,
        });
      }
      marker.addListener('click', () => {
        infowindow.open({
          anchor: marker,
          shouldFocus: false,
        });
      });
      marker.setMap(this.maps);

      this.deviceNearbyMarkers.push(marker);
    }
  }
  orderByTimestamp() {
    if (this.orderbytimestampDeviceNearbyAsc) {
      this.deviceNearbyFilter.devices = this.deviceNearbyFilter.devices.sort(
        (a: DeviceNearbyItem, b: DeviceNearbyItem) =>
          (Number(a.datetimeEvent) ?? 0) - (Number(b.datetimeEvent) ?? 0)
      );
    } else {
      this.deviceNearbyFilter.devices = this.deviceNearbyFilter.devices.sort(
        (a: DeviceNearbyItem, b: DeviceNearbyItem) =>
          (Number(b.datetimeEvent) ?? 0) - (Number(a.datetimeEvent) ?? 0)
      );
    }
  }

  numeroSerieArray: string[] = [];
  requestLastPosition(event: any): void {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      console.error('Selecione apenas um arquivo.');
      return;
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      // Pegando a primeira aba
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      // Converte para JSON
      const data = XLSX.utils.sheet_to_json(ws);
      // Extrai valores da coluna "numeroSerie"
      this.numeroSerieArray = data.map((row: any) => row.numeroSerie);
    };
    reader.readAsBinaryString(target.files[0]);
 }

sendListLastPosition() {
  const payload = {
    seriais: {
      serial: this.numeroSerieArray
    }
  };

  this.utilService.getLastPosition(payload) 
    .subscribe({
      next: (response: string) => {
        const blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'lastPosition.csv';
        link.click();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.show('Erro no processamento - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    });
  }


  movidaExpressFormGroup: any;
  movidaExpressUseDefaultPassword: boolean = true;
  movidaExpressResult: any = {
    comando1: { text: '', check: false },
    comando2: { text: '', check: false },
    comando3: { text: '', check: false },
    app: { text: '', check: false },
    lock: { text: '', check: false },
    unlock: { text: '', check: false },
  };
  validatorFn(): ValidatorFn {
    return (
      movidaExpressFormGroup: AbstractControl
    ): ValidationErrors | null => {
      let message: string[] = [];
      let error: boolean[] = [];
      let plate = movidaExpressFormGroup.get('plate')?.value;
      let serialNumber = movidaExpressFormGroup.get('serialNumber')?.value;
      let password = movidaExpressFormGroup.get('password')?.value;

      if (plate != undefined && plate != null && plate.includes(';')) {
        let plateSplit = plate.split(';');
        plate = plateSplit[0];
        if(plateSplit.length > 1){
          serialNumber = plateSplit[1];
          movidaExpressFormGroup.get('plate')?.setValue(plate);
        }
        
        if (!movidaExpressFormGroup.get('usePasswordDefault')?.value) {
          if (plateSplit.length > 2) {
            movidaExpressFormGroup.get('password')?.setValue(plateSplit[2]);
          } else {
            movidaExpressFormGroup.get('password')?.setValue('271A6');
          }
        }
    
        movidaExpressFormGroup.get('serialNumber')?.setValue(serialNumber);
        movidaExpressFormGroup.updateValueAndValidity();
      }

      plate = plate != undefined ? plate.replaceAll('-', '') : '';
      const regexPlacaMercosulCarro =
        /^[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}$/;

      if (!regexPlacaMercosulCarro.test(plate)) {
        message.push('Placa no formato incorreto, verifique!');
        error.push(true);
      }
      if (serialNumber != undefined && serialNumber.length != 12) {
        message.push('Serial incorreto, verifique!');
        error.push(true);
      }
      if (
        !movidaExpressFormGroup.get('usePasswordDefault')?.value &&
        password != null &&
        password != undefined &&
        password.length < 5
      ) {
        message.push('Insira uma senha!');
        error.push(true);
      }
      if (error.includes(true)) {
        return {
          movidaExpressError: message,
          error: true,
        };
      }
      return null;
    };
  }
  movidaExpressFormClean() {
    this.movidaExpressResult = {
      comando1: { text: '', check: false },
      comando2: { text: '', check: false },
      comando3: { text: '', check: false },
      app: { text: '', check: false },
      lock: { text: '', check: false },
      unlock: { text: '', check: false },
    };
    this.movidaExpressFormGroup.reset();
    this.movidaExpressFormGroup.get('usePasswordDefault').setValue(true);
  }

  calculateChecksum(data: Uint8Array): string {
    let sum = 0;
  
    for (let i = 0; i < data.length; i++) {
      sum += data[i];
    }
    const checksum = sum % 256;
    return checksum.toString().padStart(3, '0');
  }
  
  generateCommands() {
    const plate = this.movidaExpressFormGroup.get('plate').value;
    const serial = this.movidaExpressFormGroup.get('serialNumber').value;
    let password = '271A6';
    if (!this.movidaExpressFormGroup.get('usePasswordDefault').value) {
      password = this.movidaExpressFormGroup.get('password').value;
    }
    const textPlate = `${password}${plate}`;
    const textSerial = `${password}${serial}`;
    const datasSerial = new TextEncoder().encode(textSerial);
    const checksumSerial = this.calculateChecksum(datasSerial);
    this.movidaExpressResult[
      'comando1'
    ].text = `${checksumSerial}${textSerial}`;

    let text = new TextEncoder().encode(`${password}S`);
    let checksum = this.calculateChecksum(text);
    this.movidaExpressResult['comando2'].text = `${checksum}${password}S`;

    text = new TextEncoder().encode(`${textPlate}`);
    checksum = this.calculateChecksum(text);
    this.movidaExpressResult['comando3'].text = `${checksum}${textPlate}`;

    this.movidaExpressResult['app'].text = `${plate},${serial},${password}`;

    text = new TextEncoder().encode(`${password}T`);
    checksum = this.calculateChecksum(text);
    this.movidaExpressResult['lock'].text = `${checksum}${password}T`;

    text = new TextEncoder().encode(`${password}D`);
    checksum = this.calculateChecksum(text);
    this.movidaExpressResult['unlock'].text = `${checksum}${password}D`;
  }
}

export interface Gateway {
  serial: string;
  gateway: string;
  date: string;
  dateOrderBy: Date;
  dateWithoutConection: string;
}

new Date().valueOf();
export class LoraCache {
  serial: string;
  loraId?: number;

  constructor() {
    this.serial = '';
  }
}

export class FindMyCache {
  serial: string;
  private_key: string;

  constructor() {
    this.serial = '';
    this.private_key = '';
  }
}

export class NewEventoSupport {
  bateria_externa: NewEventoSupportAux;
  bateria_interna: NewEventoSupportAux;
  origem_mensagem: NewEventoSupportAux;
  gps: NewEventoSupportAux;
  portas: NewEventoSupportAux;

  constructor() {
    (this.bateria_externa = new NewEventoSupportAux(
      false,
      new NewEventoBateria()
    )),
      (this.bateria_interna = new NewEventoSupportAux(
        false,
        new NewEventoBateria()
      )),
      (this.origem_mensagem = new NewEventoSupportAux(false, 0)),
      (this.gps = new NewEventoSupportAux(false, new NewEventoGPS()));
    this.portas = new NewEventoSupportAux(false, [
      new NewEventoEstadoPortas(0, 1),
      new NewEventoEstadoPortas(1, 1),
    ]);
  }
}
export class NewEventoSupportAux {
  use: boolean;
  value: any;
  constructor(use: boolean, value: any) {
    this.use = use;
    this.value = value;
  }
}

export class NewEvento {
  tipo_evento: number | undefined;
  rastreador: NewEventoRastreador;
  data_hora_evento: number | string;
  data_hora_recebimento: number | string;
  bateria_externa?: NewEventoBateria;
  origem_mensagem?: number | undefined;
  gps?: NewEventoGPS;
  flags: NewEventoFlags;
  portas?: NewEventoEstadoPortas[];

  constructor() {
    (this.tipo_evento = 0),
      (this.rastreador = new NewEventoRastreador()),
      (this.data_hora_evento = ''),
      (this.data_hora_recebimento = ''),
      (this.origem_mensagem = 0),
      (this.bateria_externa = new NewEventoBateria()),
      (this.gps = new NewEventoGPS()),
      (this.flags = new NewEventoFlags());
      this.portas = [];
  }
}

export class NewEventoRastreador {
  numero_serie: string | undefined;
  fabricante: number | undefined;
  bateria_interna?: NewEventoBateria;

  constructor() {
    (this.numero_serie = undefined), (this.fabricante = 2);
  }
}

export class NewEventoFlags {
  ignicao: boolean;
  ignicao_virtual: boolean;
  posicao_online: boolean;
  bloqueador?: boolean | undefined;
  botao_panico?: boolean | undefined;
  jamming?: boolean | undefined;
  emergencia?: boolean | undefined;
  conectado_can?: boolean | undefined;
  limpadores_parabrisa?: boolean | undefined;

  constructor() {
    (this.ignicao = false),
      (this.ignicao_virtual = false),
      (this.posicao_online = false);
  }
}

export class NewEventoGPS {
  latitude: Number;
  longitude: Number;
  fixado: boolean;
  proa?: Number;
  velocidade?: Number;
  odometro: Number;
  constructor() {
    (this.latitude = 0.0), (this.longitude = 0.0), (this.fixado = false); (this.odometro = 0);
  }
}

export class NewEventoBateria {
  ativa: Boolean;
  conectada?: Number;
  tensao?: Number;
  porcentagem?: number;

  constructor() {
    this.ativa = false;
  }
}

export class NewEventoEstadoPortas {
  equipamento_porta: number;
  numero_porta: Number;
  tipo_portas: Number;
  valor_saida?: number;
  valor_entrada?: number;

  constructor(tipo_porta: number, numero_porta: number) {
    (this.equipamento_porta = 0),
      (this.numero_porta = numero_porta),
      (this.tipo_portas = tipo_porta),
      (this.valor_saida = 1);
  }
}

//parserPacket
interface Parser {
  deviceName: string;
  parserPacket: ParserPacket[];
}

interface ParserPacket {
  firmware: string[];
  type: string;
  sep: string;
  headerSep: string;
  filterGroup: string[];
  filterParam: string[];
  paramGroup: string[];
  param: string[];
  value: string[][];
  packet: string[];
}

export class DeviceNearby {
  devices: DeviceNearbyItem[];
  deviceModelDistinct: string[];
  deviceManufactorDistinct: string[];
  deviceMessageOriginDistinct: string[];
  deviceEventTypeDistinct: string[];
  constructor() {
    this.devices = [];
    this.deviceModelDistinct = [];
    this.deviceManufactorDistinct = [];
    this.deviceMessageOriginDistinct = [];
    this.deviceEventTypeDistinct = [];
  }
}
export class DeviceNearbyItem {
  serialNumber: string;
  geoLocation: string;
  manufactor: string;
  datetimeEvent: string;
  datetimeReceived: string;
  datetimeStorage: string;
  messageOrigin: string;
  eventType: string;
  deviceModel: string;
  p2p_serialNumber: string = '';
  p2p_reason: string = '';
  p2p_rssi: string = '';
  p2p_snr: string = '';
  p2p_latitude: string = '';
  p2p_longitude: string = '';
  gpsFixed: string;
  gpsAngle: number | undefined;
  gpsSpeed: number;
  positionOnline?: boolean;
  constructor(item: string) {
    let json = JSON.parse(item);
    this.serialNumber = json.rastreador.numero_serie;
    this.geoLocation = json.geoLocation;
    this.manufactor = json.rastreador.fabricante;
    this.datetimeEvent = json.data_hora_evento;
    this.datetimeReceived = json.data_hora_recebimento;
    this.datetimeStorage = json.data_hora_armazenamento;
    this.messageOrigin = json.origem_mensagem;
    this.eventType = json.tipo_evento;
    this.deviceModel = json.rastreador.versao_hardware;
    this.gpsFixed = json.gps.fixado;
    this.gpsAngle = json.gps.proa;
    this.gpsSpeed = json.gps.velocidade;
    if (json.flags) {
      this.positionOnline = json.flags.posicao_online;
    }
    if (json.p2p) {
      this.p2p_latitude = json.p2p.latitude ?? '';
      this.p2p_longitude = json.p2p.longitude ?? '';
      this.p2p_reason = json.p2p.motivo ?? '';
      this.p2p_rssi = json.p2p.rssi ?? '';
      this.p2p_snr = json.p2p.snr ?? '';
      this.p2p_serialNumber = json.p2p.numero_serie ?? '';
    }
  }
}
